var DropdownLooks;
(function (DropdownLooks) {
  DropdownLooks["Default"] = 'default';
  DropdownLooks["Primary"] = 'primary';
})(DropdownLooks || (DropdownLooks = {}));
export { DropdownLooks };